<script lang="ts" setup>
  import { ref } from 'vue';

  const props = defineProps({
    target: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selection: {
      type: Object,
      default: null,
    },
    selectionClassName: {
      type: String,
      default: "href-target--selected",
    },
  });

  const selected = ref<boolean>(props.selection?.selected);

  const handleClick = (event: MouseEvent) => {

    if(event.target){
      // elements with class "ignore-click" won't open target by default
      if ((event.target as Element).closest('.ignore-click')) {
        event.preventDefault();
        return;
      }
    }

    // goto target
    if (props.target && !props.disabled) {
      location.href = props.target;
    }

    // selectable
    if (props.selection) {
      selected.value = !selected.value;
    }
  };
</script>

<template>
  <div
    class="components__href-target"
    v-on:click="handleClick"
    v-bind:class="{
      'href-target--disabled': disabled,
      'href-target--active': !disabled && target,
      [selectionClassName]: selected,
    }"
  >
    <input
      class="selection-checkbox"
      v-if="selection"
      type="checkbox"
      v-bind:name="selection.name"
      v-bind:value="selection.value"
      v-bind:checked="selected"
    />
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.href-target--disabled {
  cursor: not-allowed;
}

.href-target--selected {
}

.selection-checkbox {
  display: none;
}
</style>
